import { gql } from '@apollo/client';

export const INSERT_STUDENT_BATCH_CLASS = gql`
  mutation insert_student_batch_classes_batch_class($objects: [student_batch_classes_batch_class_insert_input!]!) {
    insert_student_batch_classes_batch_class(objects: $objects) {
      affected_rows
    }
  }
`;

export const DELETE_STUDENT_BATCH_CLASS = gql`
  mutation delete_student_batch_classes_batch_class($where: student_batch_classes_batch_class_bool_exp!) {
    delete_student_batch_classes_batch_class(where: $where) {
      affected_rows
      returning {
        studentId
        batchClassId
      }
    }
  }
`;

export const BATCH_CLASS_BATCH_SUBJECT_CONFIGURATIONS = gql`
  query batch_class_batch_subject_configurations($where: batch_class_batch_subject_configurations_bool_exp) {
    batch_class_batch_subject_configurations(where: $where) {
      batchClassId
      batchSubjectConfigurationId
      count
    }
  }
`;

export const BATCH_CLASS_BATCH_SUBJECT_EXTRA_SLOT = gql`
  query batch_class_batch_subject_extra_slot($where: batch_class_batch_subject_extra_slot_bool_exp) {
    batch_class_batch_subject_extra_slot(where: $where) {
      batchClassId
      batchSubjectExtraSlotId
      count
    }
  }
`;
